import { createSlice } from '@reduxjs/toolkit';
import { requestPasswordResetAsync, resetPasswordAsync } from './passwordResetActions';

const initialState = { loading: false, error: null, message: null, requestId: null };
const slice = createSlice({
  name: 'passwordReset', initialState,
  reducers: { clearPasswordReset: () => initialState },
  extraReducers: builder => {
    for (const action of [requestPasswordResetAsync, resetPasswordAsync]) {
      builder.addCase(action.pending, (state, event) => {
        state.loading = true; state.error = null; state.message = null; state.requestId = event.meta.requestId;
      }).addCase(action.fulfilled, (state, event) => {
        if (state.requestId !== event.meta.requestId) return;
        state.loading = false; state.message = event.payload.message; state.requestId = null;
      }).addCase(action.rejected, (state, event) => {
        if (state.requestId !== event.meta.requestId) return;
        state.loading = false; state.requestId = null;
        state.error = event.meta.aborted ? null : event.payload || 'Unable to complete your request.';
      });
    }
  },
});
export const { clearPasswordReset } = slice.actions;
export default slice.reducer;
